/**
 * Created by Administrator on 2019/12/27.
 */
//import mixin from "@/assets/js/mixin.js";
export default {
    obj:null,
    init: async function (vue) {
        //招商
        if(vue.$store.getters.getRealChannel(false)=='cmbchina.mobile.app'){
            // 加载招商银行的 js
            console.log('初始化招商...')
            await vue.loadScript('/static/js/cmblapi.min.js');
            window.cmbAppLogOnBackLoad=function(){}
            let param={
                api:'setAppletBackButton',  
                params:{
                    btnAction:'executeJs', //支持default或executeJs
                    btnActionContent:'window.history.go(-1);' //当btnAction为executeJs时，可以在btnActionContent中写入希望执行的js代码，例如window.history.go(-1)
                },
                success:function(){
                    console.log('setCmblLeftBar success.');
                },
                fail:function(res){
                    console.log('setCmblLeftBar failed:', res);
                }
            };
            cmblapi.applet(param);
            console.log('设置招行回退按钮')
        }
    },
    // cmbchina.mobile.app channel pop window
    async setPopWindow(vm) {
        if(vm.$store.getters.getChannel != 'cmbchina.mobile.app') return;
        await vm.loadScript('/static/js/cmblapi.min.js');
        window.cmbAppLogOnBackLoad = function(){}
        const popConfig = JSON.stringify({
            api: "popWindow",
            fail: res => console.log(res)
        })
        let param={
            api:'setAppletBackButton',
            params:{
                btnAction:'executeJs',
                btnActionContent:`cmblapi.applet(${popConfig})`
            },
            success:function(){
                console.log('setCmblLeftBar success.');
            },
            fail:function(res){
                console.log('setCmblLeftBar failed:', res);
            }
        };
        cmblapi.applet(param);
        console.log("set cmbchina popWindow");
    }

}



// WEBPACK FOOTER //
// ./src/components/channelInit.js